import { render, staticRenderFns } from "./select-payment.vue?vue&type=template&id=2b27532c&scoped=true"
import script from "./select-payment.vue?vue&type=script&setup=true&lang=js"
export * from "./select-payment.vue?vue&type=script&setup=true&lang=js"
import style0 from "./select-payment.vue?vue&type=style&index=0&id=2b27532c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27532c",
  null
  
)

export default component.exports